(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-brands"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pp-brand-slider'))customElements.define('pp-brand-slider',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.querySelectorAll('button[data-direction]').forEach(button=>button.addEventListener('click',()=>{const track=this.querySelector('.pp-brand-track');track.scrollBy({left:Number(button.dataset.direction)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));}
});

  } catch(e) { console.error(e); }
})();
})();
